import React from 'react'
import { InstructionSection } from '../../user/styled'
import { t } from 'i18next'

const InstructionsSection = ({
	message,
	steps,
	stepIndex,
	isLivenessCompleted,
	isIntructionStarted
}) => {
	const renderedSteps = steps.filter(step => !step.skipRenderInHtml)

  return (
    <InstructionSection>
			<span className={`${ isLivenessCompleted ? ' text-success' : '' }`}>
				{t("videoRecorder.instructions")}
			</span>
			<ol>
				{renderedSteps.map((step, index) => {
					if ((stepIndex >= index && isIntructionStarted) || isLivenessCompleted) { 
						return (
							<li key={index}
								className={`
									${((stepIndex > index) || isLivenessCompleted) ? ' text-success' : ''} 
								`}
							>
								{step.instruction}
							</li>
						)
					 }
					return null;
				})}
					
			</ol>
			{
				((isIntructionStarted || isLivenessCompleted) && ((stepIndex >= renderedSteps.length -1))) ? (
					<div 
							style={{
							padding: '0.3rem 0.6rem',
							marginTop: '6px'
							}}
							className='alert alert-info'
							role='alert'
					>
							{message}
					</div>
				) : null
			}
			</InstructionSection>
  )
}

export default InstructionsSection